export const APP_INITIALIZE_DONE = 'APP_INITIALIZE_DONE'
export const APP_INITIALIZE_FAILED = 'APP_INITIALIZE_FAILED'